export const style = {
  container: {
    padding: "1.2rem 1.6rem 2rem 1.6rem",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  avatarContainer: {
    padding: "1.2rem 0.8rem 0.8rem 0.8rem",
    borderRadius: "0.8rem",
    background: "var(--neutral-100)",
    width: "min-content",
  },
  avatar: {
    width: "6rem",
    height: "6rem",
    borderRadius: "6rem",
  },
};
